import React from 'react';
import { useGame } from '../../context/GameContext';
import './PlayersList.css';

const PlayersList = () => {
  const { 
    game, 
    handleStartGame, 
    skipToEra1, 
    showDebug 
  } = useGame();

  if (!game) {
    return (
      <div className="players-list">
        <h3>Players</h3>
        <p>Loading players...</p>
      </div>
    );
  }

  return (
    <div className="players-list">
      <h3>Players</h3>
      <ul>
        {game.players?.map(player => {
          // Ensure player name is a string
          const displayName = typeof player.name === 'string' ? player.name : String(player.name || '');
          const isCurrentPlayer = player.id === game.currentPlayer;
          const isActivePlayer = player.id === game.activePlayer;
          
          return (
            <li 
              key={player.id} 
              className={`
                ${player.id === game.currentPlayer ? 'current-player' : ''}
                ${player.id === game.activePlayer ? 'active-player' : ''}
                ${player.ready ? 'player-ready' : ''}
              `}
            >
              <div className="player-name">
                {displayName}
                {isCurrentPlayer && <span className="you-indicator">(You)</span>}
              </div>
              
              <div className="player-status">
                {isActivePlayer && game.state !== 'era_complete' && (
                  <span className="active-indicator">Active</span>
                )}
                {player.ready && (
                  <span className="ready-indicator">Ready</span>
                )}
              </div>
            </li>
          );
        })}
      </ul>
      
      {/* Show start game button only if in waiting state */}
      {game && game.state === 'waiting' && (
        <button className="start-game-btn" onClick={handleStartGame}>
          Start Game
        </button>
      )}
      
      {/* Debug button to skip to era 1 */}
      {showDebug && game.currentEra === 0 && (
        <div className="debug-controls">
          <button className="debug-btn" onClick={skipToEra1}>
            Debug: Skip to Era 1
          </button>
        </div>
      )}
    </div>
  );
};

export default PlayersList; 